<template>
  <form @submit.prevent="submit">
    <b-card class="order-table-info">
      <fields ungrouped />
    </b-card>
    <b-card :class="'order-items'">
      <fields group="items" layout="vertical" />
      <div class="text-right">
        <b>{{ $t('orders.total_amount') }}:</b>
        {{ model.amount | currency(model.currency) }}
      </div>
    </b-card>
    <b-card>
      <b-button type="button" variant="light" class="mr-2" @click="cancel">
        <i class="icon-chevron-left"></i>
        {{ $t('general.back') }}
      </b-button>
      <b-button
        v-if="!updating || model.editable"
        type="submit"
        variant="primary"
        class="mr-2"
      >
        {{ $t('general.save') }}
      </b-button>
      <a
        v-if="invoiceUrl"
        :href="invoiceUrl"
        class="btn btn-light mr-2"
        target="_blank"
      >
        {{ $t('orders.view_invoice_pdf') }}
        <i class="icon-new-tab"></i>
      </a>
      <b-button
        v-if="updating"
        type="button"
        variant="light"
        class="mr-2"
        @click="resendNotification"
      >
        <i class="icon-envelop2"></i>
        {{ $t('orders.resend_notification') }}
      </b-button>
      <b-button
        v-if="model.cancellable && $allows('orders.update')"
        type="button"
        variant="light"
        class="mr-2"
        @click="cancelOrder"
      >
        <i class="icon-cross2"></i>
        {{ $t('orders.cancel_order') }}
      </b-button>
      <b-button
        v-if="updating && $allows('orders.delete')"
        type="button"
        variant="link"
        class="float-right text-danger"
        @click="deleteOrder"
      >
        {{ $t('general.delete') }}
      </b-button>
      <span
        v-if="updating && model.refundable && $allows('orders.refund')"
        class="float-right"
      >
        <b-button
          v-if="model.amount_refund_requested > 0"
          type="button"
          variant="link"
          class="text-danger"
          @click="refundOrder(true)"
        >
          {{
            $t('orders.refund_requested_amount', {
              amount: model.amount_refund_requested,
            })
          }}
        </b-button>
        <b-button
          type="button"
          variant="link"
          class="text-danger"
          @click="refundOrder()"
        >
          {{ $t('orders.refund_all') }}
        </b-button>
      </span>
    </b-card>
  </form>
</template>

<script>
import sumBy from 'lodash-es/sumBy'
import { ResourceFormMixin } from 'stylemix-vue-admin'
import OrdersApi from './Api'
import SystemUser from '../components/SystemUser'
import OrderItems from './OrderItems'

export default {
  name: 'OrderForm',

  components: {
    SystemUser,
    OrderItems,
  },

  mixins: [ResourceFormMixin],

  data() {
    return {
      base: 'orders',
      user: null,
      recipient: null,
      invoiceUrl: null,
    }
  },

  mounted() {
    this.loadForm().then(result => {
      if (!this.model.amount) {
        this.$set(this.model, 'amount', 0)
      }

      this.$watch(
        'model.items',
        () => {
          this.model.amount = sumBy(this.model.items, 'amount') || 0
        },
        { deep: true, immediate: true },
      )
      this.user = result.user
      this.recipient = result.recipient
      this.invoiceUrl = result.invoice_url
      this.$emit('loaded', result)
    })
  },

  methods: {
    api() {
      return new OrdersApi().setParameters({
        division_id: this.currentDivision.id,
      })
    },

    submit() {
      if (this.updating && !this.model.editable) {
        return
      }

      this.save().then(result => {
        this.$toast.success(result.message)
      })
    },

    async resendNotification() {
      if (
        !(await this.$alert.question(this.$t('orders.messages.confirm_resend')))
          .value
      ) {
        return
      }

      this.$uiBlocker(
        new OrdersApi().notification(this.model).then(result => {
          this.$toast.success(result.message)
        }),
        this.$el,
      )
    },

    async cancelOrder() {
      if (
        !(await this.$alert.question(
          this.$t('orders.messages.confirm_cancelling'),
          this.$t('orders.messages.confirm_cancelling_text'),
        )).value
      ) {
        return
      }

      this.$uiBlocker(
        new OrdersApi().cancel(this.model).then(result => {
          this.$toast.success(result.message)
          this.cancel()
        }),
        this.$el,
      )
    },

    async refundOrder(refund_requested = false) {
      if (
        !(await this.$alert.question(
          this.$t('orders.messages.confirm_refunding'),
        )).value
      ) {
        return
      }

      this.$uiBlocker(
        new OrdersApi()
          .refund(this.model, { refund_requested })
          .then(result => {
            this.$toast.success(result.message)
            this.cancel()
          }),
        this.$el,
      )
    },

    async deleteOrder() {
      if (
        !(await this.$alert.question(
          this.$t('orders.messages.confirm_deleting'),
        )).value
      ) {
        return
      }

      this.$uiBlocker(
        new OrdersApi().destroy(this.model.id).then(result => {
          this.$toast.success(result.message)
          this.cancel()
        }),
        this.$el,
      )
    },
  },
}
</script>
<style lang="scss">
.order-items {
  .col {
    &:first-child {
      max-width: 70%;
    }
    &:nth-child(2) {
      max-width: 25%;
    }
  }
  .btn {
    color: #fff;
  }
  .btn-link {
    background-color: #2196f3;
    padding-left: 0.75rem !important;
  }
  .btn-light {
    color: #fff;
    background-color: #f44336;
  }
}
</style>
